import NextTableForm from './table_form.vue';
import NextTableFieldForm from './table_field.vue';

export { NextTableFieldForm, NextTableForm };
